import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const CategorySelect = ({ title, defaultValue = null, handler, id = null }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectCategory") : title;
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedCategory(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getCategories = async () => {
    try {
      const response = await apiService.get(`api/v1/categories/store/${storeId}`);
      const activeCategories = response.filter((el) => !el.deleted);
      const availableCategories = activeCategories.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setCategories(availableCategories);
      if (id) {
        availableCategories.map((o) => {
          if (o.value == id) {
            o.isDisabled = true;
            return o;
          }
        });
      }
      if (defaultValue) {
        const selected = availableCategories.find((el) => el.value === defaultValue);
        setSelectedCategory(selected);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedCategory = categories.find((el) => el.value === defaultValue);
    if (selectedCategory) setSelectedCategory(selectedCategory);
  };

  useEffect(() => {
    if (!storeId) return;
    getCategories();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="categorySelect"
          onChange={handleChange}
          value={selectedCategory}
          options={categories}
          noOptionsMessage={() => t("messages.noCategoriesAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default CategorySelect;
